import { I18nInitOptions } from "../types";

export const I18N_CONFIG: I18nInitOptions = {
  ns: ['device-setup'],
  load: 'all',
};
